import { z } from "zod";

export const searchTextSchema = z.string().optional().catch(undefined);

export const pageSearchSchema = z.coerce.number().int().positive().optional().default(1).catch(1);

export const pageSizeSearchSchema = z.coerce
  .number()
  .int()
  .positive()
  .optional()
  .default(15)
  .catch(15);

export const listSearchBaseShape = {
  current: pageSearchSchema,
  pageSize: pageSizeSearchSchema,
  sortBy: searchTextSchema,
  sortDir: z.enum(["asc", "desc"]).optional().catch(undefined),
};
